import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CatSubProductModel } from 'src/app/model/cat-sub-product.model';

@Injectable({
  providedIn: 'root'
})
export class CatSubProductService {
  private url: string;

  ////////////////
  constructor(
    private http: HttpClient
  ) {
    this.url = environment.services_url;
  }

  //
  getAll = () => {
    return this.http.get(`${this.url}/CatSubProduct/List`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  save = (userName: string, subProduct: CatSubProductModel) => {
    return this.http.post(`${this.url}/CatSubProduct/saveCatSubProduct/${userName}`, subProduct)
      .pipe(
        map((resp: any) => resp)
      );
  }

  upload = (userName: string, file: File, replace: boolean) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userName', userName);
    formData.append('table', 'subProducto');
    formData.append('replace', String(replace));
    return this.http.post(`${this.url}/upload/save`, formData)
      .pipe(
        map((resp: any) => resp)
      );
  }

  downloadLayout = () => this.http.get(`${this.url}/CatSubProduct/DownloadLayout`, { responseType: 'blob' });
}
